import * as types from './types'
// setOrderFilterData
export const setOrderFilterData = ({ commit }, data) => {
  commit(types.SET_ORDER_FILTER_DATA, data)
}
// 呼叫骑手信息保存
export const setCallDriverInfo = ({ commit }, data) => {
  commit(types.CALL_DRIVER_INFO, data)
}
